module.exports = __webpack_public_path__ + "resources/img/img_voice_studio1_m_en.d28a2de5352d8d3e54cb04a32c40c3bc.png";